export default __webpack_public_path__ + "static/media/Bracers of the Deathstalker.605108c2.jpg";